var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('OmsTable',{attrs:{"jordan-table-config":_vm.tableConfig},on:{"on-select":_vm.onSelect,"on-select-cancel":_vm.onSelectCancel,"on-select-all":_vm.onSelectAll,"on-select-all-cancel":_vm.onSelectAllCancel,"on-page-change":_vm.pageChange,"on-page-size-change":_vm.pageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }